/* eslint-disable ember/classic-decorator-no-classic-methods */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class BulkPrintController extends Controller {
  @service
  toaster;

  @service
  print;

  @tracked
  selectedLearners = [];
  showPostContent = false;
  @tracked
  downloadInProgress = false;
  @tracked profilesToDownload = 0;
  @tracked profilesDownloaded = 0;
  @tracked
  downloadCancelled = false;

  get postsPublishedPercent() {
    if (this.profilesToDownload > 0) {
      return (this.profilesDownloaded / this.profilesToDownload) * 100;
    }
    return 0;
  }

  @action
  cancelDownload() {
    this.downloadCancelled = true;
  }

  @action
  download(downloadType) {
    if (isEmpty(this.selectedLearners)) {
      this.toaster.error('Please select learners to proceed with download.');
      return;
    }
    this.downloadInProgress = true;
    this.profilesToDownload = this.selectedLearners.length;
    this.profilesDownloaded = 0;
    this.downloadCancelled = false;
    // The downloads start when the contacts of all the learners are loaded.
    this.selectedLearners
      .reduce((previousPromise, nextLearner) => {
        return previousPromise.then(() => {
          return new Promise((resolve, reject) => {
            if (!this.downloadCancelled) {
              if (downloadType === 'Profiles') {
                this.print.profile(nextLearner, () => {
                  resolve();
                });
              } else {
                this.print.medicalSheet(nextLearner, () => {
                  resolve();
                });
              }
            } else {
              reject();
            }
          }).then(() => this.incrementProperty('profilesDownloaded'));
        });
      }, this.print.loadContacts(this.selectedLearners))
      .then(() => {
        this.downloadInProgress = false;
        this.profilesToDownload = 0;
        this.profilesDownloaded = 0;
        this.selectedLearners = [];
        this.toaster.success(`${downloadType} downloaded successfully.`);
      })
      .catch(() => {
        let errMsg = '';
        if (this.downloadCancelled) {
          errMsg = `Download Cancelled`;
        } else {
          errMsg = `Download failed. Please try again.`;
        }
        this.downloadInProgress = false;
        this.profilesToDownload = 0;
        this.profilesDownloaded = 0;
        this.selectedLearners = [];
        this.downloadCancelled = false;
        this.toaster.error(errMsg);
      });
  }

  @action
  toggleLearnerSelected(learner) {
    if (this.selectedLearners.includes(learner)) {
      this.selectedLearners = this.selectedLearners.filter(
        (l) => l !== learner,
      );
    } else {
      this.selectedLearners = [...this.selectedLearners, learner];
    }
  }

  @action
  selectAllLearners() {
    this.selectedLearners = this.model.slice();
  }

  @action
  selectNone() {
    this.selectedLearners = [];
  }
}
